"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Accordion = _ref => {
  let {
    title,
    titleRight,
    children,
    isExpanded,
    showToggle,
    className,
    color,
    size,
    paddingless,
    renderAs,
    onClick
  } = _ref;
  const [isOpen, setOpen] = (0, _react.useState)();
  (0, _react.useEffect)(() => {
    setOpen(isExpanded);
  }, [isExpanded]);
  const classNames = (0, _classnames.default)({
    'is-active': isOpen,
    'is-paddingless': paddingless,
    [`is-${size}`]: size,
    [`is-${color}`]: color
  });
  const headerClassNames = (0, _classnames.default)({
    'is-clickable': !showToggle
  });
  const handleClick = toggle => {
    if (typeof onClick === 'undefined') {
      setOpen(toggle);
    } else {
      onClick(toggle);
    }
  };
  const RenderAs = renderAs;
  return /*#__PURE__*/_react.default.createElement(RenderAs, {
    className: (0, _classnames.default)('accordion', className, classNames) || undefined
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('accordion-header', headerClassNames) || undefined,
    onClick: () => {
      if (!showToggle) {
        handleClick(!isOpen);
      }
    }
  }, title, showToggle && !titleRight && /*#__PURE__*/_react.default.createElement("i", {
    className: "toggle material-icons nested--trigger",
    onClick: () => {
      handleClick(!isOpen);
    }
  }, isOpen ? 'expand_less' : 'expand_more'), showToggle && titleRight && /*#__PURE__*/_react.default.createElement("div", {
    className: "accordian-header-right"
  }, titleRight, /*#__PURE__*/_react.default.createElement("i", {
    className: "toggle material-icons nested--trigger",
    onClick: () => {
      handleClick(!isOpen);
    }
  }, isOpen ? 'expand_less' : 'expand_more'))), /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-body"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion-content"
  }, children)));
};
Accordion.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  titleRight: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  isExpanded: _propTypes.default.bool,
  paddingless: _propTypes.default.bool,
  showToggle: _propTypes.default.bool,
  renderAs: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object]),
  color: _propTypes.default.oneOfType([_propTypes.default.oneOf(['primary', 'link', 'info', 'success', 'warning', 'danger', 'dark']), _propTypes.default.string]),
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['small', 'normal', 'medium', 'large']), _propTypes.default.string]),
  onClick: _propTypes.default.func
};
Accordion.defaultProps = {
  isExpanded: false,
  renderAs: 'article',
  showToggle: true
};
var _default = exports.default = (0, _CoreProps.withUiProps)(Accordion);
//# sourceMappingURL=Accordion.js.map